export async function submitSurvey({ botRating, channelId, comment, overallRating }) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  const includeBotRating = botRating ? `            botRating: ${botRating}\n        ` : '';

  const body = JSON.stringify({
    query: `mutation {\n    addInteractionCSATByChannelId(\n        channelId: "${channelId}"\n        overallRating: ${overallRating}\n        options: {\n            comment: "${comment}"\n${includeBotRating}}\n    ) {\n        interaction {\n            id\n            csatOverallRating\n            csatBotRating\n            csatComment\n        }\n        error {\n            message\n        }\n    }\n}\n`,
    variables: {},
  });

  const options = {
    method: 'POST',
    headers,
    body,
    redirect: 'follow' as RequestRedirect,
  };

  return await fetch(`${process.env.REACT_APP_CONNECT_API_GQL}`, options)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => new Error(error));
}
